import { render, staticRenderFns } from "./PropertyReportDigitalAppraisal.vue?vue&type=template&id=5f843b1b&scoped=true&"
import script from "./PropertyReportDigitalAppraisal.vue?vue&type=script&lang=ts&"
export * from "./PropertyReportDigitalAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f843b1b",
  null
  
)

export default component.exports